import { Box, Link, ResponsiveLayout } from "@bca/ui-library";
import React from "react";
import analytics from "./common/analytics/analytics";
import { IEventPushable } from "./common/analytics/analytics.types";

const pushSavedSearchesAnalytics = () => {
  analytics.push<IEventPushable>({
    event: {
      name: "click",
      category: "link",
      label: "all-saved-searches",
      action: "navigate",
    },
  });
};

const SavedSearchesStrip = () => {
  return (
    <Box
      height="58px"
      width="100%"
      backgroundColor="secondary-light-grey"
      display="flex"
    >
      <ResponsiveLayout display="flex" justifyContent="flex-end">
        <Link
          underline="always"
          color="primary-light-blue"
          href="/search/SavedSearches"
          onClick={pushSavedSearchesAnalytics}
          css={`
            align-self: center;
            font-size: 14px;
          `}
        >
          All Saved Searches
        </Link>
      </ResponsiveLayout>
    </Box>
  );
};

export default SavedSearchesStrip;
